import { uiSlice } from "./slice";

export const { selectTheme, selectModifierKeys } = uiSlice.selectors;
